export const Z_INDICES = {
  page: 0,
  /* For input add-ons like password input eye */
  inputButtons: 1,
  navbar: 10,
  footer: 10,
  /* Should be above input addons */
  dropdown: 11,
  notifications: 100,
  drawer: 101,
  popupBackdrop: 102,
};

export const PAGE_WIDTHS = {
  small: '400px',
};

export const MIN_HEIGHTS = {
  header: '104px',
};
